"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findIndex = void 0;
/**
 * Performance optimized version of `Array.prototype.findIndex` method.
 *
 * Returns the index of the first element that satisfies the testing function.
 * Returns -1 if no item satisfies the testing function.
 * @see https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
 *
 * **Limitations against native implementation**:
 *
 * - **`callback` is invoked for all indexes of the array**,
 * (not only for indexes with assigned values like native filter implementation), see example.
 * - **Doesn't coerce returned value from a callback to `true` or `false`**,
 * the callback has to return a boolean value directly.
 * - Doesn't accept the `scope` as last argument.
 *
 * @param {Array<T>} array - Input array.
 * @param {Function} callback - Predicate to test each element of the array.
 * Return true to select the index of the element, false otherwise.
 *
 * @return {number} Index of the first element the satisfied the testing function. Or -1.
 *
 * @example
 * import { findIndex } from '@24i/appstage-shared-perf-utils/dist/array';
 *
 * const array = ['spray', 'limit', 'elite', 'exuberant', 'destruction'];
 *
 * //const result = array.findIndex(word => word.length > 6); // slower native solution
 * const result = findIndex(array, word => word.length > 6);  // faster
 *
 * console.log(result);
 * // expected output: 3
 */
const findIndex = (array, callback) => {
    for (let i = 0, len = array.length; i < len; i++) {
        if (callback(array[i], i, array) === true) {
            return i;
        }
    }
    return -1;
};
exports.findIndex = findIndex;
